var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"type":_vm.type,"disabled":_vm.count>0 || _vm.disabled,"loading":_vm.loading,"size":"small"},on:{"click":function($event){_vm.submitForm('ruleForm')}}},[_vm._v("\n    "+_vm._s(_vm.loading ? '请稍后...' : _vm.count ? (_vm.btnText + "(" + _vm.count + ")") : _vm.btnText)+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43e3ecd1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoadingButton.vue
// module id = null
// module chunks = 